var _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgSolutionTool = function SvgSolutionTool(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000",
    height: 36,
    width: 34,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-40 -40 305 305",
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M223.476 108.41c-1.779-2.96-44.35-72.503-111.202-72.503S2.851 105.45 1.072 108.41a7.499 7.499 0 0 0 0 7.729c1.779 2.96 44.35 72.503 111.202 72.503s109.423-69.543 111.202-72.503a7.499 7.499 0 0 0 0-7.729zm-111.202 65.232c-49.925 0-86.176-47.359-95.808-61.374 9.614-14.032 45.761-61.36 95.808-61.36 49.925 0 86.176 47.359 95.808 61.374-9.614 14.031-45.761 61.36-95.808 61.36z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M112.274 61.731c-27.869 0-50.542 22.674-50.542 50.543 0 27.868 22.673 50.54 50.542 50.54 27.868 0 50.541-22.672 50.541-50.54 0-27.869-22.672-50.543-50.541-50.543zm0 86.083c-19.598 0-35.542-15.943-35.542-35.54 0-19.599 15.944-35.543 35.542-35.543s35.541 15.944 35.541 35.543c0 19.597-15.943 35.54-35.541 35.54z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M112.274 92.91c-10.702 0-19.372 8.669-19.372 19.364 0 10.694 8.67 19.363 19.372 19.363 10.703 0 19.373-8.669 19.373-19.363 0-10.695-8.67-19.364-19.373-19.364z"
  })));
};

export default SvgSolutionTool;